import React from 'react';
import { CountryPageProps } from './interfaces/ComponentProps';

function HelpRedirect({ country }: CountryPageProps) {
  React.useEffect(() => {
    const currentPath = window.location.pathname;
    const basePath = currentPath.split('/').slice(0, 2).join('/');

    window.location.replace(`${basePath}/help/${country}`);
  }, [country]);

  return null;
}

export default HelpRedirect;
